import { createContext, useCallback, useContext, useState } from 'react';

const ForgotPasswordContext = createContext();

const initialState = {
  isSent: false,
  isResent: false,
  isDisabled: false,
  countdown: 0,
  email: '',
  errorMessage: '',
  successMessage: '',
};

const ForgotPasswordProvider = ({ children }) => {
  const [state, setState] = useState(initialState);

  const updateState = useCallback((payload) => setState((prev) => ({ ...prev, ...payload })), []);

  const resetState = useCallback(() => setState(initialState), []);

  return <ForgotPasswordContext.Provider value={{ updateState, resetState, state }}>{children}</ForgotPasswordContext.Provider>;
};

export const useForgotPasswordState = () => {
  return useContext(ForgotPasswordContext);
};

export default ForgotPasswordProvider;
